<template lang="pug">
  .metadata-editor(v-if="!isEmptySchema")
    ObjectInput(:style="showMetadata ? 'width: 70%;' : 'width: 100%;'" ref="root" :schema="schema" :metadata="metadata" :disabled="disabled" :mappings="defaultMappings" @update:data="$emit('update:data', arguments[0], arguments[1])")
    PrettyJson(style="padding-left: 20px;" v-if="showMetadata" :jsonObject="metadata")
</template>

<script>
import ObjectInput from './template/ObjectInput'
import PrettyJson from '@/components/common/PrettyJson'
import defaultMappings from './template/default/mappings'

export default {
  name: 'MetadataEditor',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    metadata: {
      type: Object,
      required: false
    },
    schema: {
      type: Object,
      required: false
    },
    showMetadata: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    defaultMappings
  }),
  computed: {
    isEmptySchema() {
      return Object.keys(this.schema).length === 0;
    }
  },
  components: {
    ObjectInput,
    PrettyJson
  }
}
</script>

<style lang="scss">
.metadata-editor {
  .input-error {
    border: 1px solid #a94442
  }
  .hoverable {
    cursor: pointer;
  }
  .date-picker {
    input::placeholder {
      color: rgba(0, 0, 0, 0.42)
    }
  }
  .pull-right {
    float: right;
  }
  .flex {
    display: flex;
  }
  display: flex;
  .right-align {
    display: flex;
    margin-left: auto;
  }
  .array-input {
    .array-card-title {
      padding-bottom: 0px;
    }
    .array-card-inputs {
      padding: 0 16px 0 16px;
    }

    .float-right-vertical-align {
      float: right;
      margin-top: 5px;
    }
  }

}
</style>


// WEBPACK FOOTER //
// src/components/metadataeditor/MetadataEditor.vue